<template>
  <div ref="targetRef">
    <el-card>
      <!-- 搜索区域 -->
      <el-form
        ref="queryFormRef"
        class="queryFormClass"
        :model="queryForm"
        label-width="100px"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="时效类型：">
              <el-select
                v-model="queryForm.params.agingType"
                placeholder="请选择"
                clearable
                style="width: 100%"
                @change="handleSearchAgingTypeChange"
              >
                <el-option label="客户派送时效" :value="0" />
                <el-option label="客户闭环时效" :value="1" />
                <el-option label="内部网点时效" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户：">
              <el-select
                v-model="queryForm.params.customerId"
                filterable
                remote
                clearable
                placeholder="请输入并搜索"
                style="width: 100%"
                :remote-method="searchCustomerList"
                @focus="searchCustomerList('')"
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.username"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="渠道：">
              <el-select
                v-model="queryForm.params.channelCode"
                placeholder="请选择"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in channelList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="网点：">
              <el-select
                v-model="queryForm.params.siteId"
                placeholder="请选择"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="时效ID：">
              <el-input
                v-model.trim="queryForm.params.slaId"
                placeholder="请输入时效ID"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="刷新状态：">
              <el-select
                v-model="queryForm.params.status" placeholder="请选择" clearable
                style="width: 100%"
              >
                <el-option label="待执行" :value="0" />
                <el-option label="执行中" :value="1" />
                <el-option label="已完成" :value="2" />
                <el-option label="部分完成" :value="3" />
                <el-option label="执行失败" :value="4" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start" style="margin-top: 10px">
          <el-col :span="12">
            <el-button
              type="primary" size="mini" icon="el-icon-search"
              @click="handleSearch"
            >查询</el-button>
            <el-button icon="el-icon-refresh" size="mini" @click="handleReset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card style="margin-top: 20px">
      <!-- 表格区域 -->
      <el-table
        v-loading="loading" :data="tableData" border
        style="width: 100%" size="small"
      >
        <el-table-column
          prop="createTime" label="创建时间" min-width="150"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | parseTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户 / 渠道 / 网点"
          min-width="150"
          align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.agingType === 2">
              <el-tooltip
                :content="scope.row.customerName || '- -'"
                class="item"
                effect="dark"
                placement="top"
              >
                <span class="site-names-text">{{ scope.row.customerName || '- -' }}</span>
              </el-tooltip>
            </div>
            <span v-else>{{ scope.row.customerName || scope.row.channelCode || '- -' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="agingType" label="时效类型" min-width="120"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.agingType === 0" type="primary">客户派送时效</el-tag>
            <el-tag v-else-if="scope.row.agingType === 1" type="success">客户闭环时效</el-tag>
            <el-tag v-else-if="scope.row.agingType === 2" type="warning">内部网点时效</el-tag>
            <el-tag v-else-if="scope.row.agingType === 3" type="danger">内部大区时效</el-tag>
            <span v-else>- -</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="slaId" label="使用的时效ID" min-width="140"
          align="center"
        />
        <el-table-column
          prop="slaVersion" label="使用的时效版本" min-width="110"
          align="center"
        >
          <template slot-scope="scope">
            <span>V{{ formatVersion(scope.row.slaVersion) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="刷新范围" min-width="260" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.refreshStartTime | parseTime }} 至
              {{ scope.row.refreshEndTime | parseTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="refreshCount" label="刷新数据量" min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.refreshCount != null ? scope.row.refreshCount : '- -' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="completedEndTime" label="完成进度" min-width="210"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ getProgressText(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status" label="刷新状态" min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" type="info" effect="dark">待执行</el-tag>
            <el-tag v-else-if="scope.row.status === 1" type="primary" effect="dark">执行中</el-tag>
            <el-tag v-else-if="scope.row.status === 2" type="success" effect="dark">已完成</el-tag>
            <el-tag v-else-if="scope.row.status === 3" type="warning" effect="dark">部分完成</el-tag>
            <el-tag v-else-if="scope.row.status === 4" type="danger" effect="dark">执行失败</el-tag>
            <span v-else>- -</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createUserName" label="创建人" min-width="110"
          align="center"
        />
        <el-table-column
          label="操作" min-width="100" align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === 3 || scope.row.status === 4"
              type="text"
              size="small"
              icon="el-icon-refresh-left"
              @click="handleRetry(scope.row)"
            >重试</el-button>
            <span v-else>- -</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container" style="margin-top: 15px; text-align: right">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryForm.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="queryForm.pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  apiCustomerPage,
  getAgingRefreshTaskPage,
  createAgingRefreshTask,
  retryAgingRefreshTask,
  getCustomerChannelList
} from '@/api/customer';
import { searchSitequeryAllSite } from '@/api/lanshou';
import { parseTime } from '@/utils';
import { EventBus } from '@/utils/bus';

export default {
  name: 'AgingHistoryRefresh',
  filters: {
    parseTime(time) {
      if (!time) return '- -';
      return parseTime(time, '{y}-{m}-{d} {h}:{i}:{s}');
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      customerList: [],
      channelList: [],
      siteList: [],
      dialogCustomerList: [],
      dialogStateList: [],
      slaConfigList: [],
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          customerId: null,
          channelCode: null,
          siteId: null,
          agingType: null,
          slaId: '',
          status: null
        }
      },
      addDialog: {
        visible: false,
        submitting: false
      },
      addForm: {
        agingType: '',
        customerValue: '', // 格式为 'id~name~channelCode'
        siteState: '', // 网点所属州
        areaType: '', // 大区类型
        configId: '',
        slaId: '',
        slaVersion: null,
        slaVersionDisplay: '',
        refreshStartTime: ''
      },
      addRules: {
        agingType: [{ required: true, message: '请选择时效类型', trigger: 'change' }],
        customerValue: [{ required: true, message: '请选择客户/渠道', trigger: 'change' }],
        siteState: [{ required: true, message: '请选择网点所属州', trigger: 'change' }],
        areaType: [{ required: true, message: '请选择城镇类型', trigger: 'change' }],
        configId: [{ required: true, message: '请选择时效ID', trigger: 'change' }],
        refreshStartTime: [{ required: true, message: '请选择刷新范围起点', trigger: 'change' }]
      }
    };
  },
  computed: {
    isSlaIdDisabled() {
      if (this.addForm.agingType === 0 || this.addForm.agingType === 1) {
        return !this.addForm.customerValue;
      } else if (this.addForm.agingType === 2) {
        return !this.addForm.siteState;
      } else if (this.addForm.agingType === 3) {
        return !this.addForm.siteState || this.addForm.areaType === '';
      }
      return true;
    }
  },
  created() {
    this.getChannelList();
    this.getSiteList();
    this.getList();
  },
  mounted() {
    EventBus.$on('call-search', this.handleSearch);
  },
  beforeDestroy() {
    EventBus.$off('call-search', this.handleSearch);
  },
  methods: {
    formatVersion(version) {
      if (version == null) return '- -';
      return Number(version).toFixed(1);
    },
    getProgressText(row) {
      if (row.status === 2) {
        const timeStr = parseTime(
          row.completedEndTime || row.refreshEndTime,
          '{y}-{m}-{d} {h}:{i}:{s}'
        );
        return `${timeStr} (100%)`;
      }
      if (row.status === 0) {
        return '待执行 (0%)';
      }
      if (!row.refreshStartTime || !row.refreshEndTime) {
        return '- -';
      }
      const start = new Date(row.refreshStartTime).getTime();
      const end = new Date(row.refreshEndTime).getTime();
      const current = row.completedEndTime ? new Date(row.completedEndTime).getTime() : start;
      if (end <= start) {
        return '- -';
      }
      let pct = ((current - start) / (end - start)) * 100;
      pct = Math.min(100, Math.max(0, pct));
      const timeStr = row.completedEndTime
        ? parseTime(row.completedEndTime, '{y}-{m}-{d} {h}:{i}:{s}')
        : '未开始';
      return `${timeStr} (${pct.toFixed(1)}%)`;
    },
    // 列表查询
    getList() {
      this.loading = true;
      const postData = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        ...this.queryForm.params
      };
      if (postData.customerId && typeof postData.customerId === 'string') {
        const arr = postData.customerId.split('~');
        postData.customerId = Number(arr[0]);
      }
      getAgingRefreshTaskPage(postData)
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.records || [];
            this.total = res.data.total || 0;
          } else {
            this.$message.error(res.msg || '查询列表失败');
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSearch() {
      this.queryForm.pageNumber = 1;
      this.getList();
    },
    handleSearchConfigTypeChange() {
      this.queryForm.params.customerId = null;
      this.queryForm.params.channelCode = null;
      this.handleSearch();
    },
    getChannelList() {
      getCustomerChannelList().then((res) => {
        if (res.code === 200) {
          this.channelList = res.data || [];
        }
      });
    },
    getSiteList() {
      searchSitequeryAllSite().then((res) => {
        if (res.code === 200) {
          this.siteList = (res.data || []).map((item) => ({
            value: item.id,
            label: item.name
          }));
        }
      });
    },
    handleReset() {
      this.queryForm.params = {
        customerId: null,
        channelCode: null,
        siteId: null,
        agingType: null,
        slaId: '',
        status: null
      };
      this.customerList = [];
      this.handleSearch();
    },
    handleSearchAgingTypeChange() {
      this.queryForm.params.customerId = null;
      this.queryForm.params.channelCode = null;
      this.queryForm.params.siteId = null;
      this.customerList = [];
    },
    searchCustomerList(val = '') {
      const data = {
        pageNumber: 1, // 页码
        pageSize: 10, // 每页行数
        params: {
          quickSearch: val
        }
      };
      apiCustomerPage(data).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records || [];
        }
      });
    },
    // 弹框客户搜索

    // 重试操作
    handleRetry(row) {
      this.$confirm('确定要重新执行该历史时效数据刷新任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true;
          retryAgingRefreshTask(row.id)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('已成功提交重新执行任务');
                this.getList();
              } else {
                this.$message.error(res.msg || '提交重试失败');
              }
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    // 分页处理
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getList();
    },
    // 新增弹框显示

    // 加载已启用配置的网点所属州列表

    // 联动逻辑

    // 内部大区：选择州后清空城镇类型并加载

    // 弹框表单提交
    submitAddForm() {
      this.$refs.addFormRef.validate((valid) => {
        if (valid) {
          this.addDialog.submitting = true;
          const postData = {
            configId: this.addForm.configId,
            agingType: this.addForm.agingType,
            slaId: this.addForm.slaId,
            slaVersion: this.addForm.slaVersion,
            refreshStartTime: this.addForm.refreshStartTime
          };

          if (this.addForm.agingType === 0 || this.addForm.agingType === 1) {
            const arr = this.addForm.customerValue.split('~');
            postData.customerId = Number(arr[0]);
            postData.customerName = arr[1] || '';
            postData.channelCode = arr[2] || '';
          } else if (this.addForm.agingType === 2) {
            postData.channelCode = this.addForm.siteState;
            postData.customerName = this.addForm.siteState;
          } else if (this.addForm.agingType === 3) {
            const regionNames = {
              1: 'Capital',
              2: 'Metropolitan',
              3: 'Countryside'
            };
            const rName = regionNames[this.addForm.areaType] || '';
            postData.channelCode = rName;
            postData.customerName = this.addForm.siteState + ' - ' + rName;
          }

          createAgingRefreshTask(postData)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('历史数据刷新任务提交成功');
                this.addDialog.visible = false;
                this.handleSearch();
              } else {
                this.$message.error(res.msg || '提交任务失败');
              }
            })
            .finally(() => {
              this.addDialog.submitting = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.site-names-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>

<style scoped>
.queryFormClass {
  margin-bottom: 10px;
}
.pagination-container {
  margin-top: 15px;
}
</style>
